const enLocale = {
	title: 'Action Required',
	subtitle:
		"Please update your business' primary <span id='cp-font-semibold'>owner/billing</span> contact information below.",

	'labels.firstname': 'First Name *',
	'labels.lastname': 'Last Name *',
	'labels.emailaddress': 'Email Address *',
	'labels.country': 'Business Country *',
	'labels.phonenumber': 'Business Phone Number *',
	'labels.streetaddress': 'Business Street Address *',
	'labels.city': 'City *',
	'labels.stateprovince': 'State/Province *',
	'labels.zippostalcode': 'Zip/Postal Code *',

	'buttons.skip': 'Skip',
	'buttons.update': 'Update & Sign in',

	'errors.empty.firstname': 'First name is required.',
	'errors.empty.lastname': 'Last name is required.',
	'errors.empty.emailaddress': 'Email address is required.',
	'errors.invalid.emailaddress': 'Please enter a valid email address.',
	'errors.empty.country': 'Country is required.',
	'errors.empty.phonenumber': 'Phone number is required.',
	'errors.invalid.phonenumber': 'Phone number must contain at least 2 digits.',
	'errors.empty.streetaddress': 'Street address is required.',
	'errors.empty.city': 'City is required.',
	'errors.empty.stateprovince': 'State/province is required.',
	'errors.empty.zippostalcode': 'Zip/postal code is required.',
	'errors.invalid.zippostalcode':
		'Zip/postal code must contain at least 2 digits.',
};

export default enLocale;
